import { render, staticRenderFns } from "./CustomInputDemo.vue?vue&type=template&id=6d70b1d0"
import script from "./CustomInputDemo.vue?vue&type=script&lang=js"
export * from "./CustomInputDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports